module.exports = __webpack_public_path__ + "static/media/SmallArrow.e32d66ae.svg";